import { render, staticRenderFns } from "./PingJiBiaoZhunView.vue?vue&type=template&id=80de03d6&scoped=true"
import script from "./PingJiBiaoZhunView.vue?vue&type=script&lang=js"
export * from "./PingJiBiaoZhunView.vue?vue&type=script&lang=js"
import style0 from "./PingJiBiaoZhunView.vue?vue&type=style&index=0&id=80de03d6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80de03d6",
  null
  
)

export default component.exports